import React from "react";

const PasswordRules = ({ value = "", error }) => {
  const rules = {
    upperCase: {
      label: "One uppercase character",
      isValid: (v) => v.split("").some((c) => /[A-Z-À-Ü]/.test(c)),
      errorMsg: "Please include at least one uppercase letter",
    },
    lowerCase: {
      label: "One lowercase character",
      isValid: (v) => v.split("").some((c) => /[a-z-à-ü]/.test(c)),
      errorMsg: "Please include at least one lowercase letter",
    },
    digits: {
      label: "One number",
      isValid: (v) => v.split("").some((c) => /\d/.test(c)),
      errorMsg: "Please include at least one number",
    },
    minLength: {
      label: "8 characters minimum",
      isValid: (v) => v.length >= 8,
      errorMsg: "Password must be at least 8 characters",
    },
    specialCharacter: {
      label: "One special character",
      isValid: (v) =>
        v.split("").some((c) => /[@$!#%*?~+=&_\-\.\[\]\{\}\(\)]/.test(c)),
      errorMsg: "Please include at least one special character",
    },
  };

  return (
    <ul className="md:p-2 list-disc flex flex-wrap">
      {Object.entries(rules).map(([key, rule]) => {
        const isValid = rule.isValid(value);
        const showError = !isValid && error;

        return (
          <li
            key={key}
            title={showError ? rule.errorMsg : ""}
            className={`list-outside text-left w-full md:w-1/2 flex items-baseline text-xs p-1 ${
              isValid ? "text-gray-900" : "text-gray-400"
            }`}
          >
            <span
              className={`rounded-full w-2 h-2 mx-1 ${
                isValid ? "bg-primary-400" : "bg-gray-400"
              }`}
            ></span>
            <span className="w-10/12">{rule.label}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default PasswordRules;
